import { render, staticRenderFns } from "./AddMultipleCamera.vue?vue&type=template&id=36189902&scoped=true"
import script from "./AddMultipleCamera.vue?vue&type=script&lang=js"
export * from "./AddMultipleCamera.vue?vue&type=script&lang=js"
import style0 from "./AddMultipleCamera.vue?vue&type=style&index=0&id=36189902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36189902",
  null
  
)

export default component.exports